export const BASE_FONT = '"游明朝体 Pr6N M", "Yu Mincho Pr6N M", "ヒラギノ明朝 Pro W3", "Hiragino Mincho Pro", serif'